import {defineAsyncComponent} from 'vue';

const EstimateDecisionBasePopup = defineAsyncComponent(() =>
  import('@/views/estimateDecisions/base/EstimateDecisionBasePopup.vue'),
);
const EstimateDecisionBudgetAggregateIndex = defineAsyncComponent(() =>
  import('@/views/estimateDecisions/EstimateDecisionBudgetAggregateIndex.vue'),
);

const EstimateDecisionSettingTaskSummaryPopup = defineAsyncComponent(() =>
  import('@/views/estimateDecisions/EstimateDecisionSettingTaskSummaryPopup.vue'),
);

const EstimateDecisionAddTagetItemSummary = defineAsyncComponent(() =>
  import('@/views/estimateDecisions/EstimateDecisionAddTagetItemSummary.vue'),
);

const EstimateDecisionAddContentPopup = defineAsyncComponent(() =>
  import('@/views/estimateDecisions/EstimateDecisionAddContentPopup.vue'),
);

export function estimateDecisionRegister(app) {
  app.component('EstimateDecisionBasePopup', EstimateDecisionBasePopup);

  app.component('EstimateDecisionSettingTaskSummaryPopup', EstimateDecisionSettingTaskSummaryPopup);
  app.component('EstimateDecisionBudgetAggregateIndex', EstimateDecisionBudgetAggregateIndex);
  app.component('EstimateDecisionAddTagetItemSummary', EstimateDecisionAddTagetItemSummary);
  app.component('EstimateDecisionAddContentPopup', EstimateDecisionAddContentPopup);
}
